module.exports = __webpack_public_path__ + "static/media/angry.8e86c761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/angry.png
// module id = 124
// module chunks = 0